// extracted by css-extract-rspack-plugin
export default {"root":"GLHUgd","field-cell":"xaWI03","fieldCell":"xaWI03"};